import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { t } from '@lingui/macro';
import { Bolt, Select } from '../../helpers/icon-dictionary';
import {
  QuickSelectorWrapper,
  QuickSelectorToggleButton,
  QuickSelectorHeader,
  QuickSelectorRow,
  ColorBlock,
  QuickSelectorClearSelections,
  AllCellsIcon
} from './quick-selector.styled';
import SvgIcon from '../svg-icon/svg-icon';
import ContextModal, { ContextModalWidth } from '../context-modal';
import OutsideClickHandler from '../../helpers/hoc/close/outside-click-handler';
import { getContextCoords } from '../../helpers/utils';
import { QUICK_SELECTION } from '../../containers/course-assign/course-assign-types';

const QuickSelector = ({ i18n }) => {
  const infoRef = useRef(null);
  const dispatch = useDispatch();

  const [showContextMenu, setShowContextMenu] = useState(false);
  const [arrowPosition, setArrowPosition] = useState(0);
  const [positionXCallout, setPositionXCallout] = useState(0);
  const [positionYCallout, setPositionYCallout] = useState(0);

  const showContextModal = (e) => {
    const { posX, posArrow } = getContextCoords(e, ContextModalWidth);
    const { bottom } = infoRef.current.getBoundingClientRect();
    setPositionYCallout(bottom);
    setPositionXCallout(posX);
    setArrowPosition(posArrow);
    setShowContextMenu(true);
  };

  const handleOnSelect = (selectionType) => {
    dispatch({
      type: QUICK_SELECTION,
      selectionType
    });
    setShowContextMenu(false);
  };

  return (
    <QuickSelectorWrapper data-testid="quickselector">
      <QuickSelectorToggleButton onClick={showContextModal} ref={infoRef}>
        <SvgIcon icon={Bolt} />
      </QuickSelectorToggleButton>
      <OutsideClickHandler
        callback={() => setShowContextMenu(false)}
        forButton={`quickSelector`}
      >
        <ContextModal
          show={showContextMenu}
          positionArrow={arrowPosition}
          positionX={positionXCallout}
          positionY={positionYCallout}
        >
          <QuickSelectorHeader>
            {i18n._(t('quickSelector.select')`Select...`)}
          </QuickSelectorHeader>
          <QuickSelectorRow
            onClick={() => handleOnSelect('allCells')}
            data-testid="quick-select-all-cells"
            role="button"
            tabIndex="-1"
          >
            <AllCellsIcon>
              <SvgIcon icon={Select} />
            </AllCellsIcon>
            {i18n._(t('quickSelector.allCells')`All Cells`)}
          </QuickSelectorRow>
          <QuickSelectorRow
            data-testid="quick-select-all-assigned"
            onClick={() => handleOnSelect('allAssigned')}
            role="button"
            tabIndex="-1"
          >
            <ColorBlock colorType={'allAssigned'} />
            {i18n._(t('quickSelector.allAssigned')`All Assigned`)}
          </QuickSelectorRow>
          <QuickSelectorRow
            data-testid="quick-select-50-or-less"
            onClick={() => handleOnSelect('result50')}
            role="button"
            tabIndex="-1"
          >
            <ColorBlock colorType={'result50'} />
            {i18n._(t('quickSelector.results50')`Results <= 50%`)}
          </QuickSelectorRow>
          <QuickSelectorRow
            data-testid="quick-select-85"
            onClick={() => handleOnSelect('result85')}
            role="button"
            tabIndex="-1"
          >
            <ColorBlock colorType={'result85'} />
            {i18n._(t('quickSelector.results85')`Results >50 - 85%<`)}
          </QuickSelectorRow>
          <QuickSelectorRow
            data-testid="quick-select-100"
            onClick={() => handleOnSelect('result100')}
            role="button"
            tabIndex="-1"
          >
            <ColorBlock colorType={'result100'} />
            {i18n._(t('quickSelector.results100')`Results >= 85%`)}
          </QuickSelectorRow>
          <QuickSelectorClearSelections
            onClick={() => handleOnSelect('clearSelections')}
            role="button"
            tabIndex="-1"
          >
            {i18n._(t('quickSelector.clearSelections')`Clear Selections`)}
          </QuickSelectorClearSelections>
        </ContextModal>
      </OutsideClickHandler>
    </QuickSelectorWrapper>
  );
};

QuickSelector.propTypes = {
  i18n: PropTypes.object
};

export default QuickSelector;



// WEBPACK FOOTER //
// ./components/quick-selector/quick-selector.js